import React, { Component } from "react";
import { contractList } from "@api/settle";
import { newDate, formatDate, formatDateStr } from "@utils/tool";

let billId = "", dateStr = "";

export default class SettleContract extends Component {
    state = {
        list: [],
        partner: {},
        ownInfo: {}
    };

    componentWillMount() {
        const params = this.props.history.location.search
            .slice(1)
            .split("&")
            .map(item => item.split("=")[1]);

        billId = params[0];
        dateStr = params[1];

        this.getContractList();
        this.renderDate();
    };

    componentDidMount() {
        this.updatePage();
    };

    updatePage = () => {
        let page = this.refs.page;
        let pageHeight = page.offsetHeight;
        let windowHeight = window.innerHeight;
        if (pageHeight > windowHeight) {
            let pec = windowHeight/pageHeight + 0.01;
            page.style.transform = `scale(${pec})`;
            page.style.webkitTransform = `scale(${pec})`;
        }
    };

    getContractList = async () => {
        const res = await contractList({ billId });

        this.setState({ ...res.data.data });
    };

    renderDate = () => {
        // 本月开始及结束
        let date = newDate(formatDateStr(dateStr));
        let end = newDate(formatDateStr(dateStr));
        end.setMonth(date.getMonth() + 1);

        let nowDateStr = formatDate(newDate(), 'yyyy年MM月dd日');
        let startDateStr = formatDate(date, 'yyyy年MM月dd日');
        let endDateStr = formatDate(end.getTime() - 24 * 60 * 60 * 1000, 'yyyy年MM月dd日');

        this.setState({
            nowDateStr,
            startDateStr,
            endDateStr
        });
    };

    handlePrint = () => {
        window.print();
    };

    render() {
        return (
            <div className="page-cont">
                <div className="page-btn">
                    <div className="printBtn" onClick={this.handlePrint}>打印本页</div>
                </div>
                <div className="page" ref="page">
                    <div className="table-title">
                        <h3>《{this.state.partner.name}》渠道结算对账单</h3>
                        <div className="t-left">
                            结算周期：{this.state.startDateStr} 至 {this.state.endDateStr}
                            <br />
                            结算明细表：
                        </div>
                    </div>
                    <table className="info-table" cellSpacing="0">
                        <tbody>
                            <tr>
                                <th>产品名称</th>
                                <th>合作方式</th>
                                <th>
                                    {this.state.partner.cooperateType === 'cpa' ? '合作单价 (分)' : '分成比例 (%)'}
                                </th>
                                <th style={{display: this.state.partner.cooperateType === 'cps' ? 'block' : 'none', border: 'none'}}>充值金额</th>
                                <th style={{display: this.state.partner.cooperateType === 'cpa' ? 'block' : 'none', border: 'none'}}>新增用户</th>
                                <th>结算金额（元）</th>
                            </tr>
                            {this.state.list.map((u, index) => {
                                let temp = '';

                                if (this.state.partner.cooperateType === 'cpa') {
                                    temp = (
                                        <tr key={index} className="list-data">
                                            <td>{u.gameName}</td>
                                            <td>{u.cooperateType}</td>
                                            <td>{u.cooperateNum}</td>
                                            <td>{u.newUserNum}</td>
                                            <td>{u.divideIncome}</td>
                                        </tr>
                                    );
                                } else {
                                    temp = (
                                        <tr key={index} className="list-data">
                                            <td>{u.gameName}</td>
                                            <td>{u.cooperateType}</td>
                                            <td>{u.cooperateNum}</td>
                                            <td>{u.income}</td>
                                            <td>{u.divideIncome}</td>
                                        </tr>
                                    );
                                }

                                return temp;
                            })}
                            <tr className="list-data">
                                <td>总计</td>
                                <td colSpan="3" />
                                <td colSpan="1">{this.state.total}</td>
                            </tr>
                            <tr>
                                <td colSpan="5" />
                            </tr>
                        </tbody>
                    </table>
                    <div className="info">
                        {/* <p className="t-center" v-if="tableData.ownGameDivide!=0">自研游戏 结算金额=（充值金额-渠道费）*{{tableData.ownGameDivide}}%-税费</p>
                    <p className="t-center">结算金额=（充值金额-渠道费）*{{tableData.gameDivide}}%-税费，渠道费=充值金额*{{tableData.slotRate}}%，税费=净收入*{{tableData.taxRate}}%，结算金额=净收入-税费。</p> */}
                        <p />
                        <p>
                            *********************************************************************
                            <br />
                            以上金额确认无误，请盖章后寄回
                        </p>
                    </div>
                    <table className="info-table double" cellSpacing="0">
                        <tbody>
                            <tr className="border">
                                <td colSpan="3" width="50%">
                                    <div>{this.state.partner.name}</div>
                                    <div className="t-left">
                                        户
                                        <span
                                            style={{
                                                width: "2em",
                                                display: "inline-block"
                                            }}
                                        />
                                        名：{this.state.partner.bankAccountName}
                                        <br />开
                                        <span
                                            style={{
                                                width: ".5em",
                                                display: "inline-block"
                                            }}
                                        />
                                        户
                                        <span
                                            style={{
                                                width: ".5em",
                                                display: "inline-block"
                                            }}
                                        />
                                        行：{this.state.partner.bankName}
                                        <br />账
                                        <span
                                            style={{
                                                width: "2em",
                                                display: "inline-block"
                                            }}
                                        />
                                        号：{this.state.partner.bankAccount}
                                        <br />联
                                        <span
                                            style={{
                                                width: ".5em",
                                                display: "inline-block"
                                            }}
                                        />
                                        系
                                        <span
                                            style={{
                                                width: ".5em",
                                                display: "inline-block"
                                            }}
                                        />
                                        人：{this.state.partner.contact}
                                        <br />
                                        联系电话：{this.state.partner.mobile}
                                        <br />地
                                        <span
                                            style={{
                                                width: "2em",
                                                display: "inline-block"
                                            }}
                                        />
                                        址：{this.state.partner.address}
                                        <br />
                                    </div>
                                </td>
                                <td colSpan="3" width="50%">
                                    <div>{this.state.ownInfo.invoiceTitle}</div>
                                    <div className="t-left">
                                        联
                                        <span style={{width: '.5em', display: 'inline-block'}} />
                                        系
                                        <span style={{width: '.5em', display: 'inline-block'}} />
                                        人：{this.state.ownInfo.contact}
                                        <br />
                                        联系电话：{this.state.ownInfo.mobile}
                                        <br />地
                                        <span style={{width: '2em', display: 'inline-block'}} />
                                        址：{this.state.ownInfo.address}
                                        <br />
                                        发票抬头：{this.state.ownInfo.invoiceTitle}
                                        <br />
                                        发票类型：{this.state.ownInfo.invoiceTp}
                                        <br />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="info">
                        <div>
                            <br />
                        </div>
                        <p>对账日期： {this.state.nowDateStr}</p>
                    </div>
                </div>
            </div>
        );
    }
}
